/* eslint-disable no-unused-expressions */
import React from 'react';

type SetupResult = () => void;

const createRootElement = (id: string): HTMLElement => {
  const rootContainer = window?.document?.createElement('div');
  rootContainer?.setAttribute('id', id);

  return rootContainer;
};

const addRootElement = (rootElement: Element): void => {
  window?.document?.body?.appendChild(rootElement);
};

const usePortal = (id: string): HTMLElement => {
  const rootElementRef = React.useRef<HTMLElement>();

  const setupElement = (): SetupResult => {
    const existingParent = window?.document?.querySelector(`#${id}`);
    const parentElement = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElement);
    }

    if (rootElementRef.current) {
      parentElement?.appendChild(rootElementRef.current);
    }

    return (): void => {
      rootElementRef.current?.remove();

      if (!parentElement.childElementCount) {
        parentElement?.remove();
      }
    };
  };

  // TODO: it does not support srr build (we need to use the windowGlobal() helper)
  const getRootElement = (): HTMLElement => {
    if (!rootElementRef.current) {
      rootElementRef.current = window?.document?.createElement('div');
    }

    return rootElementRef.current;
  };

  React.useEffect(setupElement, [id]);

  return getRootElement();
};

export { usePortal };
